import React from 'react';
import './SupportPage.css';

const TermsOfService = () => {
  return (
    <div className="support-page">
      <div className="support-header">
        <h1 className="support-title">Terms of Service</h1>
        <p className="support-subtitle">
          Please read these terms carefully before using our service. By using V Football, you agree to these terms.
        </p>
      </div>
      
      <div className="support-content">
        <div className="info-box">
          <p>
            <strong>Last Updated:</strong> January 2025
          </p>
        </div>
        
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using V Football ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. 
          If you do not agree to abide by the above, please do not use this service.
        </p>
        
        <h2>2. Description of Service</h2>
        <p>
          V Football provides real-time football scores, news, statistics, and related information from various leagues and competitions worldwide. 
          The Service is provided "as is" and we reserve the right to modify, suspend, or discontinue the Service at any time.
        </p>
        
        <h2>3. User Accounts</h2>
        <h3>Account Creation</h3>
        <ul>
          <li>You may be required to create an account to access certain features</li>
          <li>You must provide accurate and complete information when creating an account</li>
          <li>You are responsible for maintaining the confidentiality of your account credentials</li>
          <li>You are responsible for all activities that occur under your account</li>
        </ul>
        
        <h3>Account Security</h3>
        <ul>
          <li>Notify us immediately of any unauthorized use of your account</li>
          <li>Use strong passwords and enable two-factor authentication when available</li>
          <li>Do not share your account credentials with others</li>
        </ul>
        
        <h2>4. Acceptable Use</h2>
        <p>You agree not to use the Service to:</p>
        <ul>
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe on intellectual property rights of others</li>
          <li>Transmit harmful, offensive, or inappropriate content</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Interfere with or disrupt the Service or servers</li>
          <li>Use automated tools to scrape or download content without permission</li>
          <li>Impersonate other users or entities</li>
          <li>Engage in any form of spam or harassment</li>
        </ul>
        
        <h2>5. Intellectual Property</h2>
        <h3>Our Content</h3>
        <p>
          All content on V Football, including but not limited to text, graphics, logos, images, and software, 
          is the property of V Football or its licensors and is protected by copyright and other intellectual property laws.
        </p>
        
        <h3>User Content</h3>
        <p>
          Any content you submit or upload to our Service remains your property, but you grant us a license to use, 
          modify, and display such content in connection with providing the Service.
        </p>
        
        <h3>Third-Party Content</h3>
        <p>
          We may display content from third-party sources. Such content is the property of its respective owners 
          and is used with permission or under fair use provisions.
        </p>
        
        <h2>6. Privacy</h2>
        <p>
          Your privacy is important to us. Please review our <a href="/privacy">Privacy Policy</a>, which also governs your use of the Service, 
          to understand our practices regarding the collection and use of your information.
        </p>
        
        <h2>7. Disclaimers</h2>
        <h3>Service Availability</h3>
        <p>
          We strive to provide continuous service but cannot guarantee 100% uptime. The Service may be temporarily unavailable 
          due to maintenance, updates, or technical issues.
        </p>
        
        <h3>Data Accuracy</h3>
        <p>
          While we make every effort to provide accurate and up-to-date information, we cannot guarantee the accuracy, 
          completeness, or timeliness of all data displayed on our Service.
        </p>
        
        <h3>Third-Party Services</h3>
        <p>
          Our Service may integrate with or link to third-party services. We are not responsible for the availability, 
          content, or practices of such third-party services.
        </p>
        
        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, V Football shall not be liable for any indirect, incidental, special, 
          consequential, or punitive damages, including but not limited to loss of profits, data, or use, arising out of 
          or in connection with your use of the Service.
        </p>
        
        <h2>9. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless V Football and its affiliates, officers, directors, employees, and agents 
          from any claims, damages, or expenses arising out of your use of the Service or violation of these Terms.
        </p>
        
        <h2>10. Termination</h2>
        <h3>Termination by You</h3>
        <p>You may terminate your account at any time by contacting us or using the account deletion feature if available.</p>
        
        <h3>Termination by Us</h3>
        <p>
          We reserve the right to suspend or terminate your access to the Service at any time, with or without cause, 
          including for violation of these Terms.
        </p>
        
        <h3>Effect of Termination</h3>
        <p>
          Upon termination, your right to use the Service will cease immediately. Provisions that should survive termination 
          will remain in effect.
        </p>
        
        <h2>11. Modifications to Terms</h2>
        <p>
          We reserve the right to modify these Terms at any time. We will notify users of material changes by posting 
          the updated Terms on our website and updating the "Last Updated" date. Continued use of the Service after 
          such changes constitutes acceptance of the modified Terms.
        </p>
        
        <h2>12. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which 
          V Football operates, without regard to conflict of law principles.
        </p>
        
        <h2>13. Dispute Resolution</h2>
        <p>
          Any disputes arising out of or relating to these Terms or the Service shall be resolved through binding arbitration 
          or in the courts of competent jurisdiction, as specified in our dispute resolution procedures.
        </p>
        
        <h2>14. Severability</h2>
        <p>
          If any provision of these Terms is found to be unenforceable or invalid, such provision shall be limited or 
          eliminated to the minimum extent necessary so that the remaining Terms shall remain in full force and effect.
        </p>
        
        <h2>15. Contact Information</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us:
        </p>
        <ul>
          <li>Email: <a href="mailto:legal@vfootball.com">legal@vfootball.com</a></li>
          <li>Contact Form: <a href="/contact">Contact Us</a></li>
        </ul>
        
        <div className="info-box">
          <p>
            <strong>Important:</strong> These Terms of Service constitute a legally binding agreement between you and V Football. 
            Please read them carefully and contact us if you have any questions before using our Service.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;